export const ARE_COOKIES_ACCEPTED = 'ARE_COOKIES_ACCEPTED';
